<div class="fail">
    <div class="main-title">
        <img src="/assets/images/marketing-agreement-popup/big-icecream.svg" alt="" class="ice-cream" />
        <h1>התהליך נכשל</h1>
        <h2>נסה שוב מאוחר יותר</h2>
    </div>
    <div class="button-wrapper">
        <a (click)="closeMarketingAgreementPopup.emit()" title="" id="finish" class="brand-button aqua-button"><span>סיימתי, תודה</span></a>
    </div>
</div>